import { gql } from '@apollo/client'

export const Query = gql`
  query FeatureRequests(
    $companyId: ID!,
  ) {
    releasedFeatureRequests: featureRequests(companyId: $companyId, filters: { generallyReleasedAtNotNull: true }) {
      nodes { id title description state }
    }
    betaFeatureRequests: featureRequests(companyId: $companyId, filters: { betaReleasedAtNotNull: true }) {
      nodes { id title description state }
    }
    startedFeatureRequests: featureRequests(companyId: $companyId, filters: { startedAtNotNull: true }) {
      nodes { id title description state }
    }
    plannedFeatureRequests: featureRequests(companyId: $companyId, filters: { approvedAtNotNull: true }) {
      nodes { id title description state }
    }
  }
`
